import { makeStyles } from "@mui/styles";
import {Theme} from "@mui/material/styles/createTheme";

export const useStyles = makeStyles<Theme>((theme) => ({
  footer: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    gap: 16,
    '@media (max-width: 767px)': {
      flexDirection: "column"
    }
  },
  title: {
    fontSize: 16,
    fontWeight: "700",
    lineHeight: "1.5",
    marginBottom: 24,
  },
  description: {
    marginBottom: 16,
  },
  subTitle: {
    fontSize: 14,
    fontWeight: "400",
    lineHeight: "1.3",
    marginBottom: 32,
    '@media (max-width: 767px)': {
      marginBottom: 48,
    }
  },
  button: {
    width: "100%",
    height: 36,
  },
  buttonDelete: {
    width: "100%",
    height: 36,
    backgroundColor: theme.palette.secondary.main,
    '&:hover': {
      backgroundColor: theme.palette.secondary.main,
    }
  },
}));
